<template>
  <div class="item-two">
    <ul class="matching-l clear">
      <li v-for="(item,index) in matchingdata" :key="index">
        <span class="matching-title">{{ item.title }}</span>
        <span class="matching-data"><i>{{ item.num }}</i><em>{{ item.unit }}</em></span>
      </li>
      <li style="width: 182px; height: 0; overflow: hidden; box-shadow: none;margin: 0;">占位</li>
    </ul>
    <div class="matching-r">
      <div class="real-time-data" :class="item.diffPrice<0?'real-time-data-fall':''" v-for="(item,index) in categorydata" :key="index">
        <p>{{ item.title }}</p>
        <div class="real-time-data-c"><span><countTo :startVal='0' :endVal='item.latestPrice' :duration='10000'></countTo></span><span><i>{{ item.diffPrice }}</i><i>{{ item.diffPercent }}%</i></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
export default {
  name: 'right-module-four',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    countTo
  },
  data(){
    return {
      matchingdata:[
        {title:'本周交易',num:0,unit:'单'},
        {title:'成交金额',num:0,unit:'万元'},
        {title:'成交数量',num:0,unit:'吨'},
        {title:'成交均价',num:0,unit:'元/吨'},
        {title:'本月合计',num:0,unit:'吨'},
        {title:'本年合计',num:0,unit:'单'}
      ],
      categorydata:[
        {title:'MEG',diffPercent:0,diffPrice:0,latestPrice:0},
        {title:'PTA',diffPercent:0,diffPrice:0,latestPrice:0}
      ]
    }
  },
  mounted () {
    this.getdata()
    this.dataRefresh.$ons('Refresh',()=>{
      this.getdata()
    })
  },
  methods: {
    getdata () {
      const url = '/api-portal/ccf/orderMatching/getData';
      const $this=this
      $this.$api.post(url, {}, (response) => {
        let datas=response.data.data||''
        if(datas){
          $this.matchingdata[0].num=datas.dealOfWeek.dealNum
          $this.matchingdata[1].num=Math.round(datas.dealOfWeek.dealPriceTotal||0)
          $this.matchingdata[2].num=datas.dealOfWeek.dealQty
          $this.matchingdata[3].num=Math.round(datas.dealOfWeek.dealPriceAvg||0)
          $this.matchingdata[4].num=datas.dealOfMonth.dealQty
          $this.matchingdata[5].num=datas.dealOfYear.dealNum
          $this.categorydata[0].diffPercent=parseFloat((datas.dealOfMeg.diffPercent||0).toFixed(2))
          $this.categorydata[0].diffPrice=Math.round(datas.dealOfMeg.diffPrice||0)
          $this.categorydata[0].latestPrice=Math.round(datas.dealOfMeg.latestPrice||0)
          $this.categorydata[1].diffPercent=parseFloat((datas.dealOfPta.diffPercent||0).toFixed(2))
          $this.categorydata[1].diffPrice=Math.round(datas.dealOfPta.diffPrice||0)
          $this.categorydata[1].latestPrice=Math.round(datas.dealOfPta.latestPrice||0)
        }
      });
    }
  }
}
</script>
<style scoped>
.item-two {
  display: flex;
  align-items: center;
  padding: 20px 20px 20px 14px;
  height: calc(100% - 20px);
  justify-content: space-around;
}

.matching-l{
  width: 345px;
  height: 208px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.matching-l li{
  width: 153px;
  height: 61px;
  background: rgba(0,0,0,.85);
  box-shadow: 1px 2px 3px 2px rgba(255,255,255,.2);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin:0 0 8px 0;
  padding: 0 5px 0 10px;
  align-items: center;
}

.matching-title{
  font-size: 14px;
  font-family: 'fzskjt';
  width: 60px;
  padding-right: 5px;
  border-right: 1px solid rgba(255,255,255,.6);
  margin-right: 7px;
  height: 42px;
  line-height: 42px;
}

.matching-data{
  width: 84px;
  display: flex;
  justify-content:space-between;
  align-content: center;
  line-height: 120%;
}

.matching-data i{
  font-size: 16px;
  font-weight: bold;
  font-family: Arial;
  font-style: normal;
}

.matching-data em{
  font-size: 13px;
  font-family: 微软雅黑;
  font-style: normal;
  font-weight: bold;
}

.real-time-data{
  width: 124px;
  height: 74px;
  background: url("../../../assets/ch_bj_h.fw.png");
  background-size: 100% 100%;
  color: #fff;
  font-family: Arial;
  font-weight: bold;
  font-size: 12px;
  margin: 15px 0;
}
.real-time-data-fall {
  background: url("../../../assets/ch_bj_l.fw.png");
}

.real-time-data p{
  height: 35px;
  width: 105px;
  padding-left: 19px;
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  line-height: 35px;
  color: rgba(255,255,255,.9);
}

.real-time-data-c{
  width: 86px;
  height: 37px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px 0 12px;
}

.real-time-data-c span:nth-child(1){
  font-size: 20px;
}

.real-time-data-c span:nth-child(2){
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/right-module-four.vue